import styled from "styled-components";

export const TopBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 32px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.text};
  box-shadow: ${({ theme }) => theme.colors.mainShadow};
  position: relative;
  z-index: 1000;

  @media (max-width: 767px) {
    /* justify-content: flex-end; */
  }
`;

export const MobileMenuToggle = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: flex;
    align-items: left;
    color: ${({ theme }) => theme.colors.secondary};
    margin-right: 16px;
    cursor: pointer;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.secondary};
  font-weight: 500;
  font-size: 0.95rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const TopBarItem = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.appSecondary};
  margin-left: 1rem;

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const Tooltip = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  top: 60px;
  right: 0px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.secondary};
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadows.secondaryShadow};
  padding: 8px;
  min-width: 200px;
  display: ${({ $isVisible }) => ($isVisible ? "flex" : "none")};
  flex-direction: column;
  gap: 4px;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const TooltipItem = styled.div`
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.appTertiary};
    color: ${({ theme }) => theme.colors.text};
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.appSecondary};
    color: ${({ theme }) => theme.colors.text};
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.subtle_8};
    color: ${({ theme }) => theme.colors.text};
  }
`;
